// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__1_e-z","footer":"ChangeClinic_footer__1GEHx"};